import TooltippedElement from "components/TooltippedElement";
import Popper from "components/react-popperv2";
import usIcon from "images/lang-icons/us.png"; // icon by Icon.doit from flaticon.com
import spainIcon from "images/lang-icons/spain.png"; // icon by Icon.doit from flaticon.com
import { useTranslation } from "react-i18next";

type Props = {
  className?: string;
};

export default function LanguageSelector({ className }: Props) {
  const { i18n, t } = useTranslation();
  const tBase = "components.languageSelector";
  const tr = (key: string) => t(`${tBase}.${key}`);

  const lang = i18n.resolvedLanguage;

  return (
    <TooltippedElement
      className={className}
      message={tr("Language")}
      element={
        <Popper
          reference={(props) => (
            <div className="relative w-10 h-10">
              <button type="button" onClick={props.open}>
                {lang === "en" ? (
                  <img alt="English" src={usIcon} />
                ) : (
                  <img alt="Español" src={spainIcon} />
                )}
              </button>
            </div>
          )}
          container={(props) => (
            <div className="flex flex-col divide-y">
              <button 
                type="button"
                className="flex items-center justify-between px-2 py-0.5 hover:bg-[#ebedef]"
                onClick={() => {
                  i18n.changeLanguage("en");
                  props.close();
                }}
              >
                English <img alt="English" src={usIcon} className="w-10 h-10 ml-2" />
              </button>
              <button 
                type="button"
                className="flex items-center justify-between px-2 py-0.5 hover:bg-[#ebedef]"
                onClick={() => {
                  i18n.changeLanguage("es");
                  props.close();
                }}
              >
                Español <img alt="Español" src={spainIcon} className="w-10 h-10 ml-2" />
              </button>
            </div>
          )}
          options={{ placement: "bottom-end", noWidth: true }}
        />
      }
    /> 
  )
}